import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import FormComponent from './FormComponent';

export default class Form extends FormComponent {
  render () {
    return <form
      className={this.props.className}
      onSubmit={ev => this.props.onSubmit && this.props.onSubmit(ev)}
      autoComplete={this.props.autoComplete}>
      {this.props.children}
    </form>;
  }
}

mergeStaticOptions(Form, {
  propTypes: {
    onSubmit: PropTypes.func,
    className: PropTypes.string,
    autoComplete: PropTypes.oneOf([
      'on',
      'off',
    ]),
  },
  defaultProps: {
    className: '',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/redux/Form.jsx